import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import Alert from "../../../alert";
import bottyCongratsIcon from '../../../../../../../../assets/images/ai-onboarding/botty-congrats.svg';
import { Button } from "reactstrap";
import { ROUTE_PATH_ADMIN_HOME } from "src/modules/3rd-party-management/constants";
import { useMutation } from "@tanstack/react-query";
import AIOnboardingService from "src/modules/3rd-party-management/apis/admin/AIOnboardingService";

const Finalize = ({
    t,
    history
}) => {
    const {
        mutate: finalizeProcessMutation
    } = useMutation({
        mutationFn: async () => {
            const service = AIOnboardingService.getInstance();
            return await service.finalizeCurrentProcess();
        }
    })

    const handleExitButtonClick = () => {
        finalizeProcessMutation()
        history.push(ROUTE_PATH_ADMIN_HOME)
    }
    
    return (
        <>
            <Alert 
                icon={bottyCongratsIcon}
                title='Congrats!'
                message='You have completed the onboarding process. You will be notified when there are new findings, overdue reports, tasks or any actions that need your attention.'
            />

            <div className="ai-onboarding-content-body">
                <div className="ai-onboarding-tab-actions">
                    <Button 
                        color="primary" 
                        onClick={handleExitButtonClick}
                    >
                        {t('Go to Third Party Management')}
                    </Button>
                </div>
            </div>
        </>
    )
}

const mapStatetoProps = (state) => {
    const { token } = state.Login;
    return {
        user          :   state.Login.user,
        token         :   token
    };
};

export default withNamespaces()(
    withRouter(connect(
        mapStatetoProps,
        {}
    )(Finalize))
)